<script lang="ts">
export default {
    name: "MiddleHeader",
};
</script>

<script setup lang="ts">
import Notice from "./notice.vue"
import { getProductInfo } from "@/api/system/index"

const urlKey = ref()
const title = ref()

onMounted(() => {
    if(sessionStorage.getItem("key")){
        urlKey.value = sessionStorage.getItem("key")
        getProductInfo(urlKey.value).then((res)=>{
            title.value = res.productName
        })
    }
})
</script>

<template>
    <div class="MiddleHeader">
        <div class="title">{{title ? title:'无人机飞控仓'}}</div>
        <Notice/>
    </div>
</template>

<style scoped lang="scss">
.MiddleHeader {
    
    .title{
        font-family: YouSheBiaoTiHei;
        font-size: 3.375rem;
        font-weight: normal;
        line-height: 63.18px;
        letter-spacing: 7.56px;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0.45) 21%, rgba(119, 186, 255, 0.45) 72%), #EFF8FC;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        // text-shadow: 0px 2px 0px rgba(255, 255, 255, 0.45), 0px 4px 1px rgba(19, 80, 143, 0.66);
        text-align: center;
        margin-bottom: 1.2vh;
    }
}
</style>
